import axios from 'axios';

import type { getLockboxesByAgentDTO } from '@bb/domain/dist/types';

const getLockboxesByAgent = async (userId: string) => {
  const { data } = await axios.get<getLockboxesByAgentDTO>(
    `/lockbox/sentrilock/user/${userId}/lockboxes`,
  );

  return data;
};

export default getLockboxesByAgent;
